var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p-3"},[_c('h1',[_vm._v("Consumer Search")]),_c('EmployeeSearch',{attrs:{"partnerId":null,"routeToEmployeeCustomerService":_vm.routeToConsumerDetail,"hideImpersonation":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }